import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { withTranslation } from 'react-i18next'
import ComboObservacionesEyaculadoEliminado from '../../components/comboObservacionesEyaculadoEliminado/ComboObservacionesEyaculadoEliminado'
import {fetchComboObservacionesEyaculadoEliminado, abrirModalVacioComboObservacionesEyaculadoEliminado, recuperarDatosModalComboObservacionesEyaculadoEliminado} from '../../actions/comboObservacionesEyaculadoEliminado/comboObservacionesEyaculadoEliminado'

export function mapStateToProps (state) {
  return {
    comboObservacionesEyaculadoEliminado: {...state.comboObservacionesEyaculadoEliminado},
    numeroRegistrosPorPagina: state.common.numeroRegistrosPorPagina,
    paginaActual: state.common.paginaActual,
    auth: state.auth
  }
}

export function mapDispatchToProps (dispatch) {
  return {
    actions: bindActionCreators({
      fetchComboObservacionesEyaculadoEliminado,
      abrirModalVacioComboObservacionesEyaculadoEliminado,
      recuperarDatosModalComboObservacionesEyaculadoEliminado
    }, dispatch)
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(ComboObservacionesEyaculadoEliminado))